/*
  mutation-types.js
    mutation type
*/

// ログイン
export const USER_LOGIN = 'USER_LOGIN'
// ログインユーザセット
export const SET_USER_LIST = 'SET_USER_LIST'
// ログイン状態更新
export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATUS'
// ログインユーザセット
export const SET_LOGIN_USER_BASE = 'SET_LOGIN_USER_BASE'
// ログインユーザセット
export const SET_LOGIN_USER = 'SET_LOGIN_USER'
// Gnssの利用可否を変更
export const CHANGE_GNSS_READY = 'CHANGE_GNSS_READY'
// ScreenViewモード切替
export const CHANGE_SCREEN_VIEW = 'CHANGE_SCREEN_VIEW'
// ScreenViewモード列数切替
//export const CHANGE_SCREEN_COLUMN = 'CHANGE_SCREEN_COLUMN'
// ScreenViewモードレイアウト切替
export const SET_SCREEN_LAYOUT = 'SET_SCREEN_LAYOUT'
// ScreenViewモード表示項目切替
export const SET_DISP_ITEM = 'SET_DISP_ITEM'
// ScreenViewモード切替間隔変更
export const SET_CAROUSEL_INTERVAL = 'SET_CAROUSEL_INTERVAL'
// Teleworkモード切替
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE'
// テレワーク勤務モード切替
export const SET_TELEWORK_FLG = 'SET_TELEWORK_FLG'
// テレワーク入力連動モード切替
export const SET_LINKED_TELEWORK = 'SET_LINKED_TELEWORK'
// 直近テレワーク勤務種別をセット
export const SET_LATEST_WH_CATEGORY = 'SET_LATEST_WH_CATEGORY'
// ユーザ選択
export const SELECT_USER = 'SELECT_USER'
// ユーザ行動予定情報リストをセット
export const SET_WHEREABOUTS_LIST = 'SET_WHEREABOUTS_LIST'
// ユーザ行動予定情報更新(選択されているユーザ)
export const UPDATE_PLACE_INFO = 'UPDATE_PLACE_INFO'
// ユーザ行動予定情報更新(選択されているユーザ)
export const UPDATE_PLACE_INFO_ASYNC = 'UPDATE_PLACE_INFO_ASYNC'
// ユーザ行動予定情報詳細更新(選択されているユーザ)
export const SET_WHEREABOUTS_INFO = 'SET_WHEREABOUTS_INFO'
// ユーザ行動予定情報詳細更新(選択されているユーザ)
export const SET_WHEREABOUTS_INFO_TO_LIST = 'SET_WHEREABOUTS_INFO_TO_LIST'
// 行先情報更新日時更新(選択されているユーザ)
export const SET_SELECT_USER_UPDATE_DATE = 'SET_SELECT_USER_UPDATE_DATE'
// セクション一覧セット
export const SET_SECTION_LIST = 'SET_SECTION_LIST'
// グループ一覧セット
export const SET_GROUP_LIST = 'SET_GROUP_LIST'
// 役職一覧セット
export const SET_CLASS_LIST = 'SET_CLASS_LIST'
// 行先一覧セット
export const SET_PLACE_LIST = 'SET_PLACE_LIST'
// 在席状態一覧セット
export const SET_PRESENCE_STATUS_LIST = 'SET_PRESENCE_STATUS_LIST'
// サーバ通信状態切り替え
export const SET_SERVER_COM_STATUS = 'SET_SERVER_COM_STATUS'
// MAP位置情報リストをセット
export const SET_GEOLOCATION_LIST = 'SET_GEOLOCATION_LIST'
// アバター画像を更新
export const SET_AVATAR_URL = 'SET_AVATAR_URL'
// アバター画像を削除
export const DELETE_AVATAR_URL = 'DELETE_AVATAR_URL'
// カレンダーキーを更新
//export const SET_CALENDAR_KEY = 'SET_CALENDAR_KEY'
// メニューからのログインユーザ行先情報の選択状態を変更する
export const SET_WA_SELECTED_ON_MENU = 'SET_WA_SELECTED_ON_MENU'
// テレワークデータリストをセット
export const SET_TELEWORK_LIST = 'SET_TELEWORK_LIST'
// テレワーク勤務中ユーザリストをセット
export const SET_TELEWORKING_USER_LIST = 'SET_TELEWORKING_USER_LIST'
// テレワーク勤務中ユーザリストに追加
export const ADD_TELEWORKING_USER_LIST = 'ADD_TELEWORKING_USER_LIST'
// テレワーク勤務中ユーザリストから削除
export const DEL_TELEWORKING_USER_LIST = 'DEL_TELEWORKING_USER_LIST'
// テレワークデータリストを追加
export const INSERT_TELEWORK_LIST = 'INSERT_TELEWORK_LIST'
// テレワークデータリストを更新
export const UPDATE_TELEWORK_LIST = 'UPDATE_TELEWORK_LIST'
// テレワークデータリストを削除
export const DELETE_TELEWORK_LIST = 'DELETE_TELEWORK_LIST'
// テレワークデータリストの休暇情報を更新
export const UPDATE_HOLIDAY_INFO = 'UPDATE_HOLIDAY_INFO'
// テレワークデータリストから休暇情報を削除
export const DELETE_HOLIDAY_INFO = 'DELETE_HOLIDAY_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js